const KosovoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111711)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#0052B4"
      />
      <path
        d="M8.78514 12.1719L9.21686 13.5006H10.6137L9.48365 14.3216L9.91529 15.6502L8.78514 14.8291L7.6549 15.6502L8.0867 14.3216L6.95654 13.5006H8.35334L8.78514 12.1719Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.1327 10.8682L13.5644 12.1968H14.9613L13.8312 13.0179L14.2629 14.3464L13.1327 13.5254L12.0026 14.3464L12.4343 13.0179L11.3042 12.1968H12.7011L13.1327 10.8682Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.4809 9.56348L17.9126 10.8921H19.3095L18.1794 11.7132L18.611 13.0418L17.4809 12.2207L16.3507 13.0418L16.7824 11.7132L15.6523 10.8921H17.0492L17.4809 9.56348Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.2153 12.1719L30.7836 13.5006H29.3867L30.5169 14.3216L30.0852 15.6502L31.2153 14.8291L32.3455 15.6502L31.9138 14.3216L33.0439 13.5006H31.647L31.2153 12.1719Z"
        fill="#F0F0F0"
      />
      <path
        d="M26.8667 10.8682L26.435 12.1968H25.0381L26.1682 13.0179L25.7365 14.3464L26.8667 13.5254L27.9968 14.3464L27.5651 13.0179L28.6952 12.1968H27.2983L26.8667 10.8682Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.5195 9.56348L22.0878 10.8921H20.6909L21.821 11.7132L21.3894 13.0418L22.5195 12.2207L23.6497 13.0418L23.2179 11.7132L24.348 10.8921H22.9512L22.5195 9.56348Z"
        fill="#F0F0F0"
      />
      <path
        d="M23.4788 20.8693L20.0005 16.5215L18.2614 17.391V19.1302L15.6527 20.8693H13.9136V23.1161C16.4626 24.1483 18.2614 26.6459 18.2614 29.565H20.0005V27.8259L21.7397 26.0867L23.4788 27.8259L25.2179 26.0867V24.3476L26.9571 21.7389L23.4788 20.8693Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111711">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default KosovoSvg;
